import { Link } from 'react-router-dom';
import { useIsAuthenticated } from '@azure/msal-react';
import { ClientOnly } from 'vite-react-ssg';

interface HeaderAuthLinkProps {
  className: string;
  onClick?: () => void;
}

function AuthAwareLink({ className, onClick }: HeaderAuthLinkProps) {
  const isAuthenticated = useIsAuthenticated();
  return (
    <Link to={isAuthenticated ? '/dashboard' : '/login'} className={className} onClick={onClick}>
      {isAuthenticated ? 'Client Portal' : 'Client login'}
    </Link>
  );
}

function StaticLoginLink({ className, onClick }: HeaderAuthLinkProps) {
  return (
    <Link to="/login" className={className} onClick={onClick}>
      Client login
    </Link>
  );
}

export function HeaderAuthLink({ className, onClick }: HeaderAuthLinkProps) {
  return (
    <ClientOnly fallback={<StaticLoginLink className={className} onClick={onClick} />}>
      {() => <AuthAwareLink className={className} onClick={onClick} />}
    </ClientOnly>
  );
}
